export const LT_ANON = 'anon';
export const LT_ECOM = 'ecom';
export const LT_CAREER = 'career';
